import { defineMessages } from 'react-intl-next';

import AiGenerativeAudioBriefingIcon from '@atlaskit/icon-lab/core/ai-generative-audio-briefing';
import TextAudioTranscriptIcon from '@atlaskit/icon-lab/core/text-audio-transcript';

import type { AudioFeature } from '@atlassian/ai-audio';

const i18n = defineMessages({
	narrationLabel: {
		id: 'audio.audio-features.narration-label',
		defaultMessage: 'Narration',
		description: 'Label for the narration feature',
	},
	briefingLabel: {
		id: 'audio.audio-features.briefing-label',
		defaultMessage: 'Briefing',
		description: 'Label for the briefing feature',
	},
});

export const audioFeatures: AudioFeature[] = [
	{
		name: 'briefing',
		translationString: i18n.briefingLabel,
		icon: AiGenerativeAudioBriefingIcon,
	},
	{
		name: 'narration',
		translationString: i18n.narrationLabel,
		icon: TextAudioTranscriptIcon,
	},
];
